import {
    Group,
    Stack,
    Text,
    Title,
} from '@mantine/core';

import {PhaseStatusBadge} from './PhaseStatusBadge.tsx';
import {StepBlock} from './StepBlock.tsx';
import {ExecutionPhase} from '../types.ts';
import {formatTimestamp} from '../../../utils/TableTimestamps.tsx';


// Extracted from executions/pages/EditPage.tsx during FNP-79 so the
// applications detail page can render the same phase UI.
const formatTimeRange = (startedAt?: string, completedAt?: string) => {
    if (!startedAt && !completedAt) {
        return 'n/a';
    }
    const start = startedAt ? formatTimestamp(startedAt) : 'pending';
    const end = completedAt ? formatTimestamp(completedAt) : 'in progress';
    return `${start} → ${end}`;
};


export const PhaseBlock = ({phase}: { phase: ExecutionPhase }) => {
    const steps = (phase.steps ?? []).slice().sort(
        (a, b) => (a.position ?? 0) - (b.position ?? 0),
    );
    return (
        <Stack gap={'sm'}>
            <Group justify={'space-between'} wrap={'nowrap'}>
                <Group gap={'xs'} wrap={'nowrap'}>
                    <Title order={5}>{phase.position}. {phase.phaseName ?? phase.id}</Title>
                    <PhaseStatusBadge status={phase.phaseStatus}/>
                </Group>
                <Text c={'dimmed'} size={'xs'}>
                    {formatTimeRange(phase.startedAt, phase.completedAt)}
                </Text>
            </Group>

            <Stack gap={'md'} pl={'md'}>
                {steps.length === 0 ? (
                    <Text size={'sm'} c={'dimmed'}>No steps recorded for this phase.</Text>
                ) : (
                    steps.map((step) => <StepBlock key={step.id} step={step}/>)
                )}
            </Stack>
        </Stack>
    );
};
